// // local
// export const domain = "http://127.0.0.1:8000/api/";
// export const domainV2 = "http://127.0.0.1:8000/api2/";
// export const imageDomain = "http://127.0.0.1:8000/storage/";

// // server test

// export const domain = "https://e-learning-api.thaichildrights.org/api/";
// export const domainV2 = "http://e-learning-api.thaichildrights.org/api2/";
// export const imageDomain = "https://e-learning-api.thaichildrights.org/storage/";
// export const adminDomain = "https://e-learning-admin.thaichildrights.org/";

// // server uat
export const domain = "https://cib-api.kisrasprint.com/api/";
export const domainV2 = "https://cib-api.kisrasprint.com/api2/";
export const imageDomain = "https://cib-api.kisrasprint.com/storage/";
export const adminDomain = "https://cib-admin-uat.kisrasprint.com/";

// Server Prod
// export const domain = "https://elearningapi.ordpmk.com/api/";
// export const domainV2 = "https://elearningapi.ordpmk.com/api2/";
// export const imageDomain = "https://elearningapi.ordpmk.com/storage/";
